import { FILTER_TYPES } from "taltech-styleguide";

export const colNumber = {
  classes: "w-20",
  dataField: "number",
  text: "Number",
  sort: true,
  filterObject: {
    defaultValue: undefined,
    minChars: 2,
    placeholder: "Number",
    type: FILTER_TYPES.TEXT,
  },
};
